import { Site } from '@debbie/common/dist/index.js';
import { Direction, } from '@debbie/common/dist/interactions/index.js';
import { useCase } from '@debbie/cortex/dist/cases/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useUsers } from '@debbie/cortex/dist/users/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import UserPreview from '../UserPreview.js';
import DefaultSummary from './DefaultSummary.js';
const CreditorMessageSummary = (props) => {
    const site = useSelector((s) => s.site);
    // Recipients are stored as user ids and resolved through the tenant's user
    // list, which only caseworkers can read — other sites get the plain summary.
    // Incoming messages have no stored recipients (the sender is shown as
    // "performed by" in the heading instead).
    if (site !== Site.Caseworker ||
        props.interaction.direction !== Direction.OUTGOING) {
        return React.createElement(DefaultSummary, { ...props, notesOutsideBox: true });
    }
    return React.createElement(CreditorMessageSummaryWithRecipients, { ...props });
};
const CreditorMessageSummaryWithRecipients = (props) => {
    const lang = useSelector((s) => s.lang);
    const caseLoadable = useCase(props.longCaseId);
    const singleCase = h.hasData(caseLoadable) ? caseLoadable.data : null;
    const creditorLoadable = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const usersLoadable = useUsers();
    const users = h.hasData(usersLoadable) ? usersLoadable.data : null;
    // An explicitly stored empty array means the message was sent without
    // notifying anyone (composer with all chips removed, or procedure-sent
    // notes). Only messages with no stored recipients at all (older messages)
    // go to the creditor's contact — mirror the send handler's fallback.
    const recipientIds = Array.isArray(props.interaction.details.recipients)
        ? props.interaction.details.recipients
        : creditor?.contactId != null
            ? [creditor.contactId]
            : [];
    const recipients = users
        ? recipientIds
            .map((id) => users.find((user) => user.id === id))
            .filter((user) => user != null)
        : [];
    const metaData = recipients.length > 0
        ? [
            {
                header: lang.interactions.to,
                body: (React.createElement(RecipientList, null, recipients.map((user) => (React.createElement(Recipient, { key: user.id },
                    React.createElement(UserPreview, { user: user }),
                    React.createElement("b", null, `${user.firstName} ${user.lastName}`.trim())))))),
            },
        ]
        : [];
    // With a recipient row the message belongs inside the box below it (same
    // layout as emails); without one the message renders plain like a note.
    return (React.createElement(DefaultSummary, { ...props, metaData: metaData, notesOutsideBox: metaData.length === 0 }));
};
const RecipientList = styled.span `
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 12px;
`;
const Recipient = styled.span `
  display: inline-flex;
  align-items: center;
`;
export default CreditorMessageSummary;
//# sourceMappingURL=CreditorMessageSummary.js.map